export default __webpack_public_path__ + "static/media/image-piccollo.304c8160.png";